import '../shared';
import './components';
import './stores';
import serviceFactory from '../../auto/autoForceServiceFactory';

window.service = serviceFactory();
